import { FC } from "react";
import { useTranslation } from "react-i18next";
import { MdCheck } from "react-icons/md";

const AvailableSeats: FC<{seatsAvailable:number}> = ({seatsAvailable}) => {
  const { t } = useTranslation();
  return (
    <div className="bg-background-success text-font-success flex items-center gap-2 rounded-md px-3 py-2 text-xs font-semibold">
        <MdCheck
          className="md:w-5 md:h-5"
        />
      <span>{t("Flights.listing.seatsLeft", { count: seatsAvailable })}</span>
    </div>
  );
};

export default AvailableSeats;
